import { Reducer } from 'redux';

import { ViewerActivityLoadAction } from '../../domains/viewerActivity/actions.types';

import { ViewerActivityLifecycle } from './types';

const initialState: ViewerActivityLifecycle = {
  fulfilled: undefined,
  rejected: undefined,
  pending: false,
};

const reducer: Reducer<ViewerActivityLifecycle, ViewerActivityLoadAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'VIEWER_ACTIVITY.LOAD_PENDING':
      return { ...initialState, pending: true };
    case 'VIEWER_ACTIVITY.LOAD_FULFILLED':
      return { ...initialState, fulfilled: action.payload.entities.viewerActivity };
    case 'VIEWER_ACTIVITY.LOAD_REJECTED':
      return { ...initialState, rejected: action.payload.error };
    default:
      return state;
  }
};

export default reducer;
